import { render, staticRenderFns } from "./ProfileVideoTable.vue?vue&type=template&id=cb2b06f0"
import script from "./ProfileVideoTable.vue?vue&type=script&lang=js"
export * from "./ProfileVideoTable.vue?vue&type=script&lang=js"
import style0 from "./ProfileVideoTable.vue?vue&type=style&index=0&id=cb2b06f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports